export default {
  creditCardPayments: [],
  enabledPaymentMethods: [],
};
